<template>
    <div>
      <!-- Cabeçalho -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Meios de Pagamento</h5>
        <b-button
          v-if="hasPermission('adicionar_parametros_meios')"
          variant="primary"
          class="d-flex align-items-center"
          @click="irParaCadastro"
        >
          <i class="bi bi-plus-circle-fill mr-2" title="Novo Cadastro"></i>
        </b-button>
      </div>
  
      <!-- Filtros -->
      <div class="d-flex mb-3" style="gap: 10px;">
        <input
          v-model="filters.meio"
          placeholder="Filtrar por meio"
          class="form-control mr-2"
          @input="filtrarMeios"
        />
        <!-- Botão Limpar Filtros -->
        <b-button
          variant="secondary"
          @click="limparFiltros"
          class="d-flex align-items-center justify-content-center"
        >
          <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
        </b-button>
      </div>
  
      <!-- Tabela -->
      <b-table
        :items="meios"
        :fields="fields"
        striped
        hover
        @sort-changed="onSortChanged"
      >
        
        <!-- Template para coluna "Criado" -->
        <template #cell(criado_em)="row">
          {{ formatDate(row.item.criado_em) }}
        </template>
        
        <!-- Template para coluna "Atualizado" -->
        <template #cell(atualizado_em)="row">
          {{ formatDate(row.item.atualizado_em) }}
        </template>
        
        <!-- Template para coluna do Operador (nome) -->
        <template #cell(nome_operador)="row">
          {{ row.item.nome_operador || 'Não informado' }}
        </template>
        
        <template #cell(actions)="row">
          <div class="text-end">
            <i
              v-if="hasPermission('detalhar_parametros_meios')"
              class="bi bi-eye-fill text-primary mx-2"
              title="Detalhar"
              @click="detalharMeio(row.item.id)"
            ></i>
            <i
              v-if="hasPermission('alterar_parametros_meios')"
              class="bi bi-pencil-fill text-warning mx-2"
              title="Editar"
              @click="editarMeio(row.item.id)"
            ></i>
            <i
              v-if="hasPermission('excluir_parametros_meios')"
              class="bi bi-trash-fill text-danger mx-2"
              title="Excluir"
              @click="excluirMeio(row.item.id)"
            ></i>
          </div>
        </template>
      </b-table>
  
      <!-- Controles de Paginação -->
      <div class="d-flex justify-content-center align-items-center mt-3" style="gap: 10px;">
        <b-button
          @click="paginaAnterior"
          :disabled="paginaAtual === 1"
          variant="light"
          class="p-1 d-flex align-items-center"
        >
          <i class="bi bi-chevron-left"></i>
        </b-button>
  
        <span>Página {{ paginaAtual }} de {{ totalPaginas }}</span>
  
        <b-button
          @click="proximaPagina"
          :disabled="paginaAtual >= totalPaginas"
          variant="light"
          class="p-1 d-flex align-items-center"
        >
          <i class="bi bi-chevron-right"></i>
        </b-button>
  
        <select
          v-model="limitePorPagina"
          @change="alterarLimite"
          class="form-select form-select-sm"
          style="width: 10%;"
        >
          <option value="10">10 registros</option>
          <option value="15">15 registros</option>
          <option value="20">20 registros</option>
        </select>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import { BButton, BTable } from "bootstrap-vue-next";
  
  export default {
    components: { BButton, BTable },
    data() {
      return {
        meios: [],
        fields: [
          { key: "nome_operador", label: "Operador", sortable: true },
          { key: "meio", label: "Meio de pagamento", sortable: true },
          { key: "criado_em", label: "Criado", sortable: true },
          { key: "atualizado_em", label: "Atualizado", sortable: true },
          { key: "actions", label: "Ações", class: "text-end" },
        ],
        filters: { meio: '' },
        paginaAtual: 1,
        limitePorPagina: 10,
        totalPaginas: 1,
        currentSort: { key: "meio", order: "asc" },
      };
    },
    methods: {
      async carregarMeios() {
        try {
          const response = await axios.get('/financeiro/parametros/meios', {
            params: {
              page: this.paginaAtual,
              limit: this.limitePorPagina,
              meio: this.filters.meio || undefined,
              sortBy: this.currentSort.key,
              order: this.currentSort.order,
            },
          });
          this.meios = response.data.data.map(item => ({
            ...item,
          }));
          this.totalPaginas = response.data.totalPages;
        } catch (error) {
          console.error('Erro ao carregar meios:', error.message);
        }
      },
      formatDate(data) {
        if (!data) return "Não informado";
        return new Date(data).toLocaleString();
      },
      alterarLimite() {
        this.paginaAtual = 1;
        this.carregarMeios();
      },
      filtrarMeios() {
        this.paginaAtual = 1;
        this.carregarMeios();
      },
      async excluirMeio(id) {
        // Exibe o modal de confirmação customizado e aguarda a resposta do usuário
        const confirmou = await this.$confirm(
          "Tem certeza que deseja excluir este meio?",
          "Confirmação"
        );

        if (confirmou) {
          try {
            await axios.delete(`/financeiro/parametros/meios/${id}`, {
              validateStatus: function (status) {
                return status >= 200 && status < 300; // Apenas status 2xx serão considerados sucesso
              }
            });

            // Atualiza a listagem após a exclusão bem-sucedida
            this.carregarMeios();
            this.$toast.success("Meio excluído com sucesso!");
          } catch (error) {
            console.error("Erro ao excluir meio:", error);

            let mensagem = "Erro inesperado ao excluir meio.";
            if (error.response && error.response.data) {
              mensagem = error.response.data.error || "Erro ao excluir meio.";
            }
            
            // Exibe o alerta customizado com a mensagem de erro
            await this.$alert(mensagem, "Não permitido");
          }
        }
      },
      onSortChanged(ctx) {
        this.currentSort.key = ctx.sortBy;
        this.currentSort.order = ctx.sortDesc ? 'desc' : 'asc';
        this.carregarMeios();
      },
      paginaAnterior() {
        if (this.paginaAtual > 1) {
          this.paginaAtual--;
          this.carregarMeios();
        }
      },
      proximaPagina() {
        if (this.paginaAtual < this.totalPaginas) {
          this.paginaAtual++;
          this.carregarMeios();
        }
      },
      limparFiltros() {
        this.filters.meio = '';
        this.paginaAtual = 1;
        this.carregarMeios();
      },
      irParaCadastro() {
        this.$router.push('/financeiro/parametros/meios/novo');
      },
      editarMeio(id) {
        this.$router.push(`/financeiro/parametros/meios/${id}`);
      },
      detalharMeio(id) {
        this.$router.push(`/financeiro/parametros/meios/${id}/detalhar`);
      },
    },
    async mounted() {
      await this.fetchPermissions();
      this.carregarMeios();
    },
  };
  </script>
  